import login from './login';
import loginUsingToken from './loginUsingToken';
import logout from './logout';
import register from './register';
import registerEmail from './registerEmail';
import checkBusiness from './checkBusiness';
import token from './token';
import personalInfo from './personalInfo';
import resendConfirmation from './resendConfirmation';
import resetPassword from './resetPassword';
import updatePassword from './updatePassword';
import verifySmsTwoFactorCode from './verifySmsTwoFactorCode';
import resendSmsTwoFactorCode from './resendSmsTwoFactorCode';
import verifyGoogleTwoFactorCode from './verifyGoogleTwoFactorCode';

export default {
  login,
  logout,
  register,
  registerEmail,
  checkBusiness,
  token,
  personalInfo,
  resendConfirmation,
  resetPassword,
  updatePassword,
  loginUsingToken,
  verifySmsTwoFactorCode,
  resendSmsTwoFactorCode,
  verifyGoogleTwoFactorCode,
};



// WEBPACK FOOTER //
// ./src/app/services/auth/index.js